import { MDBBtn, MDBDateTimepicker, MDBModalFooter } from 'mdb-react-ui-kit';
import React, { forwardRef, useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { addToLocation, updateLocation, updateLunaSettings } from '../../../apiclients/streamsapi_bridge';

const AddHolidays = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [defaultValuess, setDefaultValuess] = useState({});
    const [uniqueid, setUniqueId] = useState("");
    const [fromDateTime, setFromDateTime] = useState("");
    const [toDateTime, setToDateTime] = useState("");


    const { register, setValue, getValues, handleSubmit, formState: { isDirty, dirtyFields, errors }, setError, reset, clearErrors } = useForm({
        defaultValues: {
            name: "",
            from: "",
            to: ""
        }
    });

    const handleFromChange = useCallback((value) => {
        // if (!value) return;

        const formattedValue = value ? value.replace(",", "") : value
        setValue("from", formattedValue, { shouldDirty: true });
        setFromDateTime(formattedValue);
        clearErrors("from");
        clearErrors("to");
    }, [setValue, clearErrors]);

    const handleToChange = useCallback((value) => {
        // if (!value) return;

        const formattedValue =value ? value.replace(",", "") : value
        setValue("to", formattedValue, { shouldDirty: true });
        setToDateTime(formattedValue);
        clearErrors("to");
        clearErrors("from");
    }, [setValue, clearErrors]);

    useEffect(() => {
        if (props.editObj && Object.keys(props.editObj).length > 0) {
            const from = props.editObj.from ?? "";
            const to = props.editObj.to ?? "";

            reset({
                name: props.editObj.name ?? "",
                from,
                to,
            });

            setUniqueId(props.editObj.id ?? "");
            setFromDateTime(from);
            setToDateTime(to);
        }
    }, [props.editObj, reset]);




    const onSubmit = async (data) => {
        if (isDirty) {
            let update = {}

            //alert(uniqueid);
            if (props.isEdit) {
                let moObj = {
                    holiday_id: uniqueid,
                };
                for (const field of Object.keys(dirtyFields)) {
                    if (field == 'name') {
                        moObj.name = data.name;
                    }
                    if (field == 'from') {
                        moObj.from = data.from;
                    }
                    if (field == 'to') {
                        moObj.to = data.to;
                    }

                }
                props.setIsloading(true);

                if (props.lunaid) {
                    await sendEditApiForLuna(moObj, data);


                } else {

                    update = {
                        reqid: 37,
                        location_id: parseInt(props.locationid),
                        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                        holidays: {
                            update_holidays: [moObj],
                        }
                    }
                    console.log("request for update holiday ::::: " + JSON.stringify(update));
                    let saverep = await updateLocation(update);
                    props.setIsloading(false);
                    let saverepeMsg = await saverep.json();
                    console.log("Reponse for update  call blocking ::::: " + JSON.stringify(saverepeMsg));

                    if (saverepeMsg.status && saverepeMsg.status === "success") {
                        props.setSuccessMessage(saverepeMsg.message);
                        const modifiedObj = {
                            holiday_id: uniqueid,
                            name: data.name,
                            from: data.from ?
                                data.from.replace(/(a|am)\b/gi, 'AM').replace(/(p|pm)\b/gi, 'PM') :
                                data.from,
                            to: data.to ?
                                data.to.replace(/(a|am)\b/gi, 'AM').replace(/(p|pm)\b/gi, 'PM') :
                                data.to,
                            isEdited: true,
                        };
                        props.modifyObj(modifiedObj);
                        props.addEditFlag(true);
                        props.onClose();

                    } else {
                        displaySeverError(saverepeMsg);

                    }
                }

            } else {
                let mObj = {
                    name: data.name,
                    from: data.from,
                    to: data.to,
                }
                props.setIsloading(true);
                if (props.lunaid) {
                    await sendAddApiForLuna(mObj, data);

                } else {
                    update = {
                        reqid: 59,
                        location_id: parseInt(props.locationid),
                        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                        holidays: {
                            add_holidays: [mObj],
                        }
                    }
                    // update.add_holidays.name = data.name;
                    // update.add_holidays.from = data.from;
                    // update.add_holidays.to = data.to;
                    console.log(" create white and black  " + JSON.stringify(update))
                    let saverep = await addToLocation(update);
                    props.setIsloading(false);

                    let saverepeMsg = await saverep.json();
                    console.log("reposnse of add :::::::" + JSON.stringify(saverepeMsg));

                    if (saverepeMsg.status && saverepeMsg.status == "success") {
                        const id = saverepeMsg.added_holidays[0].holiday_id ?? "";
                        const modifiedObj = {
                            holiday_id: id,
                            name: data.name,
                            from: data.from ?
                                data.from.replace(/(a|am)\b/gi, 'AM').replace(/(p|pm)\b/gi, 'PM') :
                                data.from,
                            to: data.to ?
                                data.to.replace(/(a|am)\b/gi, 'AM').replace(/(p|pm)\b/gi, 'PM') :
                                data.to,
                        };
                        props.setSuccessMessage(saverepeMsg.message);
                        props.modifyObj(modifiedObj);
                        props.addEditFlag(true);
                        props.onClose();

                    } else {
                        displaySeverError(saverepeMsg);
                    }
                }

            }
        }
    }

    const sendEditApiForLuna = async (moObj, data) => {
        let update = {
            reqid: 149,
            lunaid: props.lunaid ? parseInt(props.lunaid) : "",
            schedule_id : props?.schedule_id,
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            holidays: {
                update_holidays: [moObj],
            }
        }
        console.log("request for update holiday ::::: " + JSON.stringify(update));
        let saverep = await updateLunaSettings(update);
        props.setIsloading(false);
        let saverepeMsg = await saverep.json();
        console.log("Reponse for update  call blocking ::::: " + JSON.stringify(saverepeMsg));

        if (saverepeMsg.status && saverepeMsg.status === "success") {
            props.setSuccessMessage(saverepeMsg.message);


            const modifiedObj = {
                holiday_id: uniqueid,
                name: data.name,
                from: data.from ?
                    data.from.replace(/(a|am)\b/gi, 'AM').replace(/(p|pm)\b/gi, 'PM') :
                    data.from,
                to: data.to ?
                    data.to.replace(/(a|am)\b/gi, 'AM').replace(/(p|pm)\b/gi, 'PM') :
                    data.to,
                isEdited: true,
            };
            props.modifyObj(modifiedObj);
            props.addEditFlag(true);
            props.onClose();

        } else {
            displaySeverError(saverepeMsg);

        }

    }

    const sendAddApiForLuna = async (mObj, data) => {
        let update = {
            reqid: 149,
            lunaid: props.lunaid ? parseInt(props.lunaid) : "",
            schedule_id : props?.schedule_id,
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            holidays: {
                add_holidays: [mObj],
            }
        }
        console.log(" create white and black  " + JSON.stringify(update))
        let saverep = await updateLunaSettings(update);
        props.setIsloading(false);

        let saverepeMsg = await saverep.json();
        console.log("reposnse of add :::::::" + JSON.stringify(saverepeMsg));

        if (saverepeMsg.status && saverepeMsg.status == "success") {
            const id = saverepeMsg?.added_holidays[0]?.holiday_id ?? "";
            const modifiedObj = {
                holiday_id: id,
                name: data.name,
                from: data.from ?
                    data.from.replace(/(a|am)\b/gi, 'AM').replace(/(p|pm)\b/gi, 'PM') :
                    data.from,
                to: data.to ?
                    data.to.replace(/(a|am)\b/gi, 'AM').replace(/(p|pm)\b/gi, 'PM') :
                    data.to,
            };
            props.setSuccessMessage(saverepeMsg.message);
            props.modifyObj(modifiedObj);
            props.addEditFlag(true);
            props.onClose();

        } else {
            displaySeverError(saverepeMsg);
        }

    }

    function displaySeverError(saverepeMsg) {
        if (saverepeMsg.message?.errors) {
            saverepeMsg.message.errors.forEach((err) => {
                let paramName = "";
                if (err.param_name.includes("add_holidays.name") || err.param_name.includes("update_holidays.name")) {
                    paramName = "name";
                }
                if (err.param_name.includes("add_holidays.from") || err.param_name.includes("update_holidays.from")) {
                    paramName = "from";
                }

                if (err.param_name.includes("add_holidays.to") || err.param_name.includes("update_holidays.to")) {
                    paramName = "to";
                }

                setError(paramName, {
                    type: "server",
                    message: err.message,
                });
            });
        }
    }
    return (
        <>
            <div>
                <div className="tel-numbers">
                    <strong>{t("name")}</strong>
                </div>
                <div className="form pt-1">
                    <input
                        type="text"
                        maxLength={30}
                        className="form-control w-100"
                        {...register("name", { required: "Name should not be empty",
                              setValueAs: (v) => v?.trim(),
                         })}
                    />
                    {errors.name && (
                        <p className="text-danger">{errors.name.message}</p>
                    )}
                </div>
                <div className='d-flex justify-content-between'>
                    <div className="tel-numbers mt-2 w-50">
                        <strong>From</strong>
                        <div className="form pt-1 w-100  mt-2">
                            <MDBDateTimepicker
                                inline
                                dateFormat="mm/dd/yyyy"
                                value={fromDateTime}
                                {...register("from", { required: "Please select From date and time" })}
                                onChange={handleFromChange}
                            />
                            {errors.from && (
                                <p className="text-danger">{errors.from.message}</p>
                            )}
                        </div>
                    </div>

                    <div className="tel-numbers mt-2 w-50">
                        <strong className="ms-2">To</strong>
                        <div className="form pt-1 w-100 ps-2 mt-2">
                            <MDBDateTimepicker
                                inline
                                dateFormat="mm/dd/yyyy"
                                value={toDateTime}
                                {...register("to", { required: "Please select To date and time" })}
                                onChange={handleToChange}
                            />
                            {errors.to && (
                                <p className="text-danger">{errors.to.message}</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={handleSubmit(onSubmit)}>
                    {props.isEdit ? t("save") : t("add")}
                </button>
            </div>
        </>
    )
});

export default AddHolidays
